import React from 'react';
import { Modal, Button, Typography, Space } from 'antd';

/**
 * Interface for import result data
 */
interface ImportResult {
  successCount: number;
  errorCount: number;
  errors: Array<{
    row: number;
    employeeCode: string;
    message: string;
  }>;
}

/**
 * Result Modal Component to display import results
 */
interface ResultModalProps {
  visible: boolean;
  onClose: () => void;
  data: ImportResult | null;
}

const ResultModal: React.FC<ResultModalProps> = ({ visible, onClose, data }) => {
  const { Text, Title } = Typography;
  
  if (!data) return null;
  
  return (
    <Modal
      open={visible}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Kết quả import</span>
        </div>
      }
      onCancel={onClose}
      width={600}
      footer={
        <Space style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="primary" onClick={onClose}>
            Đóng
          </Button>
        </Space>
      }
      centered
    >
      <div style={{ marginBottom: '16px' }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          marginBottom: '16px',
          background: '#f6f6f6',
          padding: '16px',
          borderRadius: '8px'
        }}>
          <div>
            <Text style={{ fontSize: '15px', color: 'green', fontWeight: 'bold' }}>
              Thành công: <span style={{ fontSize: '18px' }}>{data.successCount}</span> dòng
            </Text>
          </div>
          <div>
            <Text style={{ fontSize: '15px', color: 'red', fontWeight: 'bold' }}>
              Thất bại: <span style={{ fontSize: '18px' }}>{data.errorCount}</span> dòng
            </Text>
          </div>
        </div>
        
        {data.errorCount > 0 && (
          <>
            <Title level={5} style={{ marginBottom: '12px' }}>Chi tiết lỗi:</Title>
            <div 
              style={{ 
                maxHeight: '350px', 
                overflowY: 'auto',
                border: '1px solid #f0f0f0',
                borderRadius: '8px',
                padding: '4px'
              }}
            >
              {data.errors.map((err, idx) => (
                <div 
                  key={idx} 
                  style={{ 
                    padding: '12px', 
                    borderBottom: idx < data.errors.length - 1 ? '1px solid #f0f0f0' : 'none',
                    background: idx % 2 === 0 ? '#fafafa' : 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px'
                  }}
                >
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <div style={{ 
                      background: '#ff4d4f', 
                      color: 'white', 
                      borderRadius: '50%', 
                      width: '24px', 
                      height: '24px', 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      fontWeight: 'bold',
                      fontSize: '12px'
                    }}>
                      {idx + 1}
                    </div>
                    <Text strong>Dòng {err.row}</Text>
                  </div>
                  <div style={{ marginLeft: '32px' }}>
                    <Text type="secondary">Mã NV: </Text>
                    <Text strong>{err.employeeCode}</Text>
                  </div>
                  <div style={{ marginLeft: '32px' }}>
                    <Text type="secondary">Lỗi: </Text>
                    <Text type="danger">{err.message}</Text>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default ResultModal;
export type { ImportResult };
